import config from '@conf'
import request from '../request'
import { onRequest } from '../request/interceptors'

export const upload = params => {
  return request.post(`/wecom/oss/upload`, params)
}

export const uploadToPublic = params => {
  return request.post(`/wecom/oss/upload_to_public`, params)
}

const readMap = new Map()

export const fileRead = filename => {
  if (!readMap.has(filename)) {
    readMap.set(
      filename,
      fetch(
        `${request.defaults.baseURL}/wecom/oss/read?fileNm=${filename}`,
        onRequest({ headers: {} })
      )
        .then(res => {
          if (res.status === 200) return res.blob()
          return Promise.reject(new Error(res.statusText))
        })
        .catch(error => {
          if (config.isProduction) {
            readMap.delete(filename)
          }
          return Promise.reject(error)
        })
    )
  }
  return readMap.get(filename)
}
